import {
    init,
    SelectList,
} from 'one-state-core';

import {
    RINGCENTRAL_CLICKTOCALL
} from './types';

import {
    Actions,
} from './actions';

import {
    clicktocallState
} from './model';

export const ringCentralClickTocall = (
    context: any,
    initial?: SelectList<clicktocallState>,
) => {
    let initValue = initial || null;

    return (
        state = initValue,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state || initValue;
        switch (type) {
            case RINGCENTRAL_CLICKTOCALL:
                updated = init<clicktocallState>(
                    updated,
                    payload as clicktocallState[],
                );
                break;

           
        }
        return updated;
    }
};